<template>
    <v-list nav dense subheader>
        <v-subheader>{{ header }}</v-subheader>
        <router-link
            v-for="(item, index) in links"
            v-bind:key="index"
            v-bind:to="getTo(item)"
            v-slot="{ navigate, isExactActive }"
        >
            <v-list-item
                link
                v-bind:class="[isExactActive && exactActiveClass]"
                v-on:click="navigate"
            >
                <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    {{ item.text }}
                </v-list-item-content>
            </v-list-item>
        </router-link>
    </v-list>
</template>

<script>
// links is and array of objects with properties: icon, text,
// and either to (relative url) or name. name takes precedence.
export default {
    props: {
        header: String,
        links: Array
    },
    data() {
        return {
            exactActiveClass: 'v-list-item--active'
        };
    },
    methods: {
        getTo(item) {
            if (item.name) {
                return {
                    name: item.name
                };
            }
            return item.to;
        }
    }
};
</script>
